<div *ngIf="loading" class="spinner-container"><i class="fa fa-spinner fa-spin"></i></div>
